function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M-685-1417h1920V636H-685z"
}), React.createElement("path", {
  d: "M-685-1060h1920V909H-685z"
}), React.createElement("g", {
  transform: "translate(-70 -52)"
}, React.createElement("g", {
  transform: "translate(70 52.303)"
}, React.createElement("path", {
  d: "M30.354 17.5c.565 0 1.025.46 1.025 1.025s-.46 1.026-1.025 1.026H23.72a3.088 3.088 0 0 0-3.076 3.076v13.586h28.71V22.627a3.088 3.088 0 0 0-3.076-3.076h-6.697c-.565 0-1.025-.46-1.025-1.026 0-.565.46-1.025 1.025-1.025h6.697a5.106 5.106 0 0 1 3.625 1.502 5.1 5.1 0 0 1 1.502 3.625v16.118c0 1.514-.377 3.02-1.092 4.354a9.258 9.258 0 0 1-3.018 3.324L38.333 52.4v13.498c0 .222-.072.438-.206.616L35.82 69.59a1.026 1.026 0 0 1-1.64 0l-2.307-3.076a1.025 1.025 0 0 1-.206-.616V52.4l-8.963-5.977a9.26 9.26 0 0 1-3.018-3.324 9.254 9.254 0 0 1-1.092-4.354V22.627a5.102 5.102 0 0 1 1.502-3.625A5.109 5.109 0 0 1 23.72 17.5zm5.928 35.924a5.13 5.13 0 0 1-2.564 0v12.133L35 67.266l1.282-1.71zm10.887-9.52H22.83c.309.297 10.463 7.115 10.463 7.115a3.071 3.071 0 0 0 3.412 0S46.86 44.2 47.17 43.904zm2.186-5.64h-13.33v3.589H48.65a7.173 7.173 0 0 0 .706-3.108v-.48zm-15.38 0h-13.33v.481c0 1.094.248 2.153.706 3.108h12.624v-3.589zm8.715-15.842c.567 0 1.026.46 1.026 1.025v9.024a1.026 1.026 0 0 1-2.051 0v-3.487h-3.589v3.487a1.026 1.026 0 0 1-2.05 0v-9.024a1.026 1.026 0 0 1 2.05 0v3.487h3.589v-3.487c0-.566.46-1.025 1.025-1.025zm-12.607.103c2.146 0 3.892 1.607 3.892 3.583 0 1.976-1.746 3.583-3.892 3.583h-.355l-1.393.006v2.671a1.026 1.026 0 0 1-2.05 0V23.55c0-.025 0-.044.002-.06a1.025 1.025 0 0 1 1.023-.965zm0 2.05h-1.748v3.071h.235l.483-.003.675-.002h.355c.998 0 1.84-.702 1.84-1.533 0-.83-.842-1.533-1.84-1.533zm4.885-7.075a1.025 1.025 0 1 1 0 2.05 1.025 1.025 0 0 1 0-2.05z",
  fill: "currentColor"
}), React.createElement("circle", {
  fill: "#FC0",
  cx: 35,
  cy: 4.375,
  r: 4.375
}))), React.createElement("text", {
  fontFamily: "BNPPSans, BNPP Sans",
  fontSize: 16,
  transform: "translate(-70 -56.72)"
}, React.createElement("tspan", {
  x: 76.656,
  y: 138.719
}, "4,5 - 5,5"), React.createElement("tspan", {
  x: 78.008,
  y: 158.719
}, "Kwa\u015Bna")));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 70,
    height: 71
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/ph_yellow.edbe2970.svg";
export { SvgComponent as ReactComponent };